/* eslint-disable */
// jshint ignore: start
import store from '@/store';
import { MapInfo, MapUtil } from '@/views/topologymap/js/maps';
/**
 * 배경 격자
 * @param       {[type]} graph    Qunee Graph
 * @constructor
 */
(function(Q) {
  function Background(graph) {
      this.graph = graph;
      graph.delayedRendering = false;
      graph.onPropertyChange('viewport', this.update.bind(this));
      graph.onPropertyChange('transform', this.update.bind(this));
      // graph.onPropertyChange('graphModel', this.changeModel.bind(this));
      graph.onPropertyChange('customimageId', this.imageUpdate.bind(this));

      this.canvas = Q.createCanvas(this.graphWidth(), this.graphHeight(), true);
      this.canvas.style.position = 'absolute';
      this.canvas.style.top = '0px';
      this.canvas.style['-webkit-user-select'] = 'none';
      this.canvas.style['-webkit-tap-highlight-color'] = 'rgba(0, 0, 0, 0)';

      this.scaleCanvas = Q.createCanvas(this.graphWidth(), this.graphHeight(), true);
      this.scaleCanvas.style.position = 'absolute';
      this.scaleCanvas.style.top = '0px';
      this.scaleCanvas.style['-webkit-user-select'] = 'none';
      this.scaleCanvas.style['-webkit-tap-highlight-color'] = 'rgba(0, 0, 0, 0)';

      this.imageCanvas = Q.createCanvas(this.graphWidth(), this.graphHeight());
      this.imageCanvas.style.position = 'absolute';
      this.imageCanvas.style.top = '0px';
      this.imageCanvas.style['-webkit-user-select'] = 'none';
      this.imageCanvas.style['-webkit-tap-highlight-color'] = 'rgba(0, 0, 0, 0)';

      graph.canvasPanel.insertBefore(this.canvas, graph.canvasPanel.firstChild);
      graph.canvasPanel.insertBefore(this.imageCanvas, graph.canvasPanel.firstChild);
      graph.canvasPanel.appendChild(this.scaleCanvas);

      this.graph._getOverviewScaleInfo = function () {
          var elementBounds = this.bounds;
          if (this.background && this.background.bounds) {
              elementBounds = elementBounds.union(this.background.bounds);
          }
          if (!elementBounds.isEmpty()) {
              var xScale = this.width / elementBounds.width;
              var yScale = this.height / elementBounds.height;
              var scale = Math.min(xScale, yScale);
              scale = Math.max(this.minScale, Math.min(this.maxScale, scale));
              return {scale: scale, cx: elementBounds.cx, cy: elementBounds.cy};
          }
      };
      this.graph.zoomToOverview = function (byAnimate, maxScale) {
          return this.callLater(function () {
              var scaleInfo = this._getOverviewScaleInfo();
              if (scaleInfo) {
                  if (maxScale) {
                      scaleInfo.scale = Math.min(scaleInfo.scale, maxScale);
                  }
                  this.centerTo(scaleInfo.cx, scaleInfo.cy, scaleInfo.scale, false);
              }
          }, this);
      };

      this.update();
  }

  Background.prototype = {
      changeModel: function() {
        var graph = this.graph,
            canvas = this.canvas,
            scaleCanvas = this.scaleCanvas,
            canvasCtx = canvas.getContext('2d'),
            scaleCanvasCtx = scaleCanvas.getContext('2d');

        canvasCtx.clearRect(0, 0, canvas.width, canvas.height);
        scaleCanvasCtx.clearRect(0, 0, scaleCanvas.width, scaleCanvas.height);

        if(graph.topologymapModel) {
          this.image = store.getters.getImageUrlById(graph.topologymapModel.customimageId);
        }

        this.update(this);

        if (!this.image) {
          MapInfo.getInstance(this.graph).getCanvas().updateZoom();
        }
      },
      update: function () {
          this.gridUpdate();
          this.imageUpdate();
      },
      gridUpdate: function() {
        var graph = this.graph;
        var canvas = this.canvas;
        var scaleCanvas = this.scaleCanvas;

        if(!graph || !graph.topologymapModel) {
          return false;
        }

        this.show = graph.topologymapModel.gridShowFlag == '1' || false;
        this.editable = graph.editable || false;
        this.gap = graph.topologymapModel.gridSize || 20;
        this.color = (this.show && graph.topologymapModel.strokeOptions.color) || '#808080';
        this.alpha = graph.topologymapModel.strokeOptions.alpha || 0.3;
        this.width = graph.topologymapModel.strokeOptions.weight || 1;

        if(!this.editable && !this.show) {
          return false;
        }

        graph.callLater(function () {
            canvas.setSize(this.graphWidth(), this.graphHeight());
            canvas.width = canvas.width;//clear canvas
            scaleCanvas.setSize(this.graphWidth(), this.graphHeight());
            scaleCanvas.width = canvas.width;//clear canvas

            var scale = graph.scale;
            var gap = this.gap / scale;
            var currentCell = this.currentCell = 10 * (Math.round(gap / 10) || 1);

            scale = graph.scale * canvas.ratio;
            var bounds = graph.viewportBounds;
            var g = canvas.g;

            g.save();
            this._doTransform(g, scale, bounds);

            g.beginPath();
            var x = bounds.x, y = bounds.y, right = bounds.right, bottom = bounds.bottom;
            if (x % currentCell !== 0) {
                x -= (x % currentCell);
            }
            if (y % currentCell !== 0) {
                y -= (y % currentCell);
            }

            x += 0.5;
            while (x < right) {
                g.moveTo(x, bounds.y);
                g.lineTo(x, bottom);
                x += currentCell;
            }

            y += 0.5;
            while (y < bottom) {
                g.moveTo(bounds.x, y);
                g.lineTo(right, y);
                y += currentCell;
            }

            g.lineWidth = this.width / scale;
            g.strokeStyle = MapUtil.hexToRgbA(this.color, this.alpha);
            g.stroke();

            scaleCanvas.g.save();
            this._doTransform(scaleCanvas.g, scale, bounds);
            if(this.editable) {
              this.drawScales(scaleCanvas.g, bounds, scale, scaleCanvas.ratio);
            }
            scaleCanvas.g.restore();

            g.restore();
        }, this);
      },
      colorUpdate: function() {
        var graph = this.graph;

        if(!graph || !graph.topologymapModel) {
          return false;
        }

        this.imageCanvas.style.opacity = 1;
        this.imageCanvas.g.fillStyle = '#ffffff';
        this.imageCanvas.g.fillRect(0, 0, this.graphWidth(), this.graphHeight());

        if(graph.topologymapModel.fillType == 'Solid Fill') {
            var backgroundColor = graph.topologymapModel.fillOptions.color;
            var backgroundAlpha = graph.topologymapModel.fillOptions.alpha;

			this.imageCanvas.style.opacity = backgroundAlpha;
            this.imageCanvas.g.fillStyle = MapUtil.hexToRgbA(backgroundColor, 1);
            this.imageCanvas.g.fillRect(0, 0, this.graphWidth(), this.graphHeight());
        }
      },
      imageUpdate: function() {
        var graph = this.graph;
        var image = this._imageTarget;

        var imageCanvas = this.imageCanvas;

        imageCanvas.width = this.graphWidth();//clear canvas
        imageCanvas.height = this.graphHeight();//clear canvas

        this.colorUpdate();

        if(!graph || !graph.topologymapModel) {
          return false;
        }

        if(!image) {
          return;
        }

        var g = imageCanvas.g;

        g.save();
        g.translate(graph.tx, graph.ty);
        g.scale(graph.scale, graph.scale);

        try {
          g.drawImage(image, -(image.width/2), -(image.height/2), image.width, image.height);
        } catch (e) {
        } finally {
        }

        g.restore();
      },
      _doTransform: function(g, scale, bounds){
          g.translate(-scale * bounds.x, -scale * bounds.y);
          g.scale(scale, scale);
      },_onImageLoad: function (evt) {
          if (evt.target != this._imageTarget) {
              return;
          }
          this.bounds = new Q.Rect(-(this._imageTarget.width/2), -(this._imageTarget.height/2), this._imageTarget.width, this._imageTarget.height);
          this.imageUpdate();
          // this.graph.limitedBounds = this.bounds;

          MapInfo.getInstance(this.graph).getCanvas().updateZoom();
      },
      drawText: function (g, text, x, y, fontSize, textAlign, textBaseline, rotate) {
          fontSize = fontSize || 7;
          g.save();
          var fontScale = 3;
          fontSize *= fontScale;
          g.font = 'normal ' + fontSize + 'px 나눔고딕';
          g.fillStyle = '#808080';
          g.textAlign = textAlign || 'center';
          g.textBaseline = textBaseline || 'top';
          g.translate(x, y);
          if (rotate) {
              g.rotate(rotate);
          }
          g.scale(1 / fontScale, 1 / fontScale);
          g.fillText(text, 0, 0);
          g.restore();
      },
      drawScales: function (g, bounds, scale, ratio) {
          g.beginPath();

          var scaleLength = 2 * ratio / scale;
          var fontSize = 11 * ratio / scale;

          var textInterval = this.currentCell <= 30 ? 3 : this.currentCell <= 20 ? 4 : this.currentCell <= 10 ? 5 : null;
          var index=0;


          g.beginPath();
          var x = bounds.x;
          x = this.currentCell * Math.ceil(x / this.currentCell);
          x += 0.5;
          while (x < bounds.right) {
              g.moveTo(x, bounds.y);
              g.lineTo(x, bounds.y + scaleLength + scaleLength);
              if(textInterval == null || index++ % textInterval == 0) {
                this.drawText(g, '' + x | 0, x, bounds.y + scaleLength + scaleLength + (scaleLength * 3), fontSize);
              }
              x += this.currentCell;
          }

          index = 0;

          var y = bounds.y;
          y = this.currentCell * Math.ceil(y / this.currentCell);
          y += 0.5;
          while (y < bounds.bottom) {
              g.moveTo(bounds.x, y);
              g.lineTo(bounds.x + scaleLength + scaleLength, y);

              if(textInterval == null || index++ % textInterval == 0) {
                this.drawText(g, '' + y | 0, bounds.x + scaleLength + scaleLength + (scaleLength * 3), y, fontSize, 'left', 'middle');
              }
              y += this.currentCell;
          }
          g.lineWidth = 1 / scale;
          g.strokeStyle = MapUtil.hexToRgbA('#808080', 0.3);
          g.stroke();
      },
      graphWidth: function() {
        return (this.graph && this.graph.html && this.graph.width) || 0;
      },
      graphHeight: function() {
        return (this.graph && this.graph.html && this.graph.height) || 0;
      }
  }
  Object.defineProperties(Background.prototype, {
  	image: {
  		get: function() {
  			return this._image;
  		},
  		set: function(v) {
        try {
          this._image = v;
          if (!v) {
            this.imageCanvas.width = this.graphWidth();//clear canvas
            this.imageCanvas.height = this.graphHeight();//clear canvas
            this._imageTarget = null;
            //2018.03.29 : 이미지가 설정된 맵에서는 이미지의 크기로 graph의 bounds를 설정함.
            //이미지가 없는 다른 맵으로 이동 시 graph의 bounds를 초기화 하는 작업이 필요.
            this.bounds = null;
            return;
          }
          var image = this._imageTarget = document.createElement('img');
          image.src = this._image;
          image.onload = this._onImageLoad.bind(this);
        } catch (e) {
          // ignore
        }
  		}
  	}
  })
  Q.Background = Background;
})(window.Q);
// jshint ignore:end
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/background.js